
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../base/BaseComponent";
import {Button, Divider, Input, Modal, Progress, Select} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import close from "../view/Resource/img/close.png";
import outlined from "../view/Resource/img/expend-outlined.png";
import $ from "jquery";
import {uuid} from "../../../utils";
import SimpleFloatTool from "../../editor/floatTool/simpleFloatTool";


export default class UploadStatus extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};
    constructor(props) {
        super(props);
        this.state = {
            isClose: true,//控制上传弹框是否显示
            visible:false,
            minus: false,
            dragIng: false,
            right:0,
            top:0,
            show:false,
        }
    }


    componentWillMount() {

    }

    componentDidMount() {


    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.getList();
        this.handleRemove();

    }
    render() {

        const errorColor = "#f56c6c";
        let status, text, show;
        this.props.fileList && this.props.fileList.length > 0 && this.props.fileList.forEach((item, index) => {
            status = item.status;
        });
        let top = document.body.clientHeight-292;
        const isError = status === "error";
        text = '上传中（' + this.props.fileList.length + '）';

        if(!this.props.fileList.length){
            return <></>
        }
        return(

            <SimpleFloatTool
                style={{border: 'none'}}
                top={top}
                title={text}
                showClose={false}
                left={document.body.clientWidth < 1280 ? document.body.clientWidth - 240 : 1280}
                width={500}
                minus={false}
                onClose={()=>{
                    this.simpleFloatTool.hide()
                }}
                footer={null}
                ref={simpleFloatTool => this.simpleFloatTool = simpleFloatTool}
            >
                    <Scrollbars    autoHeight
                                   className={'upLoadStatus'}
                                   autoHide
                                   autoHeightMax={180}
                                  >
                        {this.props.fileList && this.props.fileList.length > 0 && this.props.fileList.map((item, index) => {

                            if(item.originFileObj && item.originFileObj.cancelUpload){
                                return <></>;
                            }
                            return (
                                <div key={index}>
                                        <div>
                                            <div style={{marginTop: '5px',width:'350px'}} className={'twoText'} title={item.name}>{item.name}</div>
                                            <div style={{display: 'flex',width:'100%'}}>
                                                <Progress strokeColor={isError ? errorColor : ""}
                                                          showInfo={true}
                                                          status={isError?'exception':'active'}
                                                          percent={item.url ? 100 : parseInt(item.percent)}/>
                                                <div style={{
                                                    width: '50px',
                                                    color: '#1890ff',
                                                    marginLeft: '15px',
                                                    cursor: 'pointer'
                                                }} onClick={() => {
                                                    this.cancelUpload(item)
                                                }}> 取消
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            )
                        })}

                    </Scrollbars>

            </SimpleFloatTool>

        )

    }

    cancelUpload=(file)=>{
        let fileList = this.props.fileList.filter(Item => Item.uid !== file.uid);
        this.props.cancelUpload&&this.props.cancelUpload(file);
        this.props.callBack&&this.props.callBack(fileList);

    };
    getList(){
       if(this.props.fileList.length>0){
           this.simpleFloatTool && this.simpleFloatTool.show()
       }else{
           this.simpleFloatTool && this.simpleFloatTool.hide()
       }
    }
    handleRemove() {
            this.props.fileList && this.props.fileList.length > 0 && this.props.fileList.forEach((item, index) => {
                if (item.url) {

                        let fileList = this.props.fileList.filter(Item => Item.uid !== item.uid);
                        this.props.callBack&&this.props.callBack(fileList)

                }
            })
    };


}